import api from './api'

export const leaveService = {
  // Get all leaves (HR/Admin) or own leaves (Employee)
  getAllLeaves: async () => {
    const response = await api.get('/leaves')
    return response.data
  },

  // Get leave by ID
  getLeaveById: async (id) => {
    const response = await api.get(`/leaves/${id}`)
    return response.data
  },

  // Create new leave request
  createLeave: async (leaveData) => {
    const response = await api.post('/leaves', leaveData)
    return response.data
  },

  // Update leave status (Approve/Reject) - HR/Admin only
  updateLeaveStatus: async (id, statusData) => {
    const response = await api.put(`/leaves/${id}/status`, statusData)
    return response.data
  },

  // Cancel leave request - Employee only
  cancelLeave: async (id) => {
    const response = await api.put(`/leaves/${id}/cancel`)
    return response.data
  },

  // Get employees on leave today
  getEmployeesOnLeaveToday: async () => {
    const response = await api.get('/leaves/on-leave-today')
    return response.data
  }
}
